// The homepage proof-of-work section (components/home-v2/ProofV2.jsx) shows
// this many case studies, with only these fields. Shared by the server page,
// which seeds the section, and the client section, which refreshes it, so the
// server-to-client hand-off carries three small cards rather than full studies.
export const PROOF_LIMIT = 3

export const proofCard = (study) => ({
  id: study.id ?? null,
  slug: study.slug ?? null,
  title: study.title ?? '',
  image: study.image ?? null,
  category: study.category ?? null,
  excerpt: study.excerpt || study.challenge || '',
})
